import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import { CircuitPreset } from '@neon-one/neon-circuit';
import type { App } from 'vue';

import '@/styles/circuit.css';
import '@/styles/tokens.css';

export function installTheme(app: App): void {
  app.use(PrimeVue, {
    theme: {
      preset: CircuitPreset,
      options: {
        darkModeSelector: '.app-dark',
      },
    },
  });
  // v-tooltip directive — used by Lane C1's disabled-Bid-CTA on
  // BidCard when the auction is paused, and similar future
  // explainer hovers.
  app.directive('tooltip', Tooltip);
}
